
import { PlusOutlined } from '@ant-design/icons';
import { Avatar, Input, Card, Col, List, Row, Space, Switch, Tag, Tooltip, Form, Button, Modal } from 'antd';
import { Alert } from 'components/elements';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { addEmailToMailCompany, deleteEmailToMailCompany, getEmailToMailCompany, updateStatusEmailToMailCompany } from '../service/settingMailnotiApi';
import { SETTING_MAIL_NOTI, setEmailNotificationList, setIsLoading } from '../slices/settingMailNotiSlice';
import { MailOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
const useSettingNoti = () => {
    const dispatch = useDispatch();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    const { isLoading, emailNotificationList } = useSelector((state) => state?.[SETTING_MAIL_NOTI]);
    const { t, i18n } = useTranslation();


    const ListItemForm = ({ item, onFormFinish }) => {
        const [form] = Form.useForm();
        return (
            <Form
                autoComplete="off"
                form={form}
                onFinish={() => {
                    onFormFinish(item.id, form.getFieldsValue())
                    form.resetFields()
                }}
                onFinishFailed={() => { console.log("fail") }}
                layout="vertical"
            >
                <Form.Item
                    name="email"
                    label={t("configuration.label.email_Recipients")}
                    tooltip={t("configuration.label.email_enter")}
                    rules={[
                        {
                            type: 'email',
                            message: t('email.validate.email'),
                        },
                        {
                            // required: true,
                            message: t('email.validate.require'),
                        }
                    ]}
                >
                    <Col span={8}>
                        <Input onPressEnter={() => form.submit()} />
                    </Col>
                </Form.Item>
            </Form>
        );
    };
    const getMyLeaveRequestPagingWithoutPendingList = useCallback(
        async (params) => {
            try {
                dispatch(setIsLoading(true));
                const res = await getEmailToMailCompany({
                    companyId: params.currentCompany,
                    employeeId: params.currentEmployee,
                }).then(res => {
                    dispatch(setEmailNotificationList(res?.data?.content))
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch],
    )

    const updateStatusEmailToMail = useCallback(
        async (
            { id,
                currentEmployee,
                active,
                currentCompany,
            }) => {
            try {
                // dispatch(setIsLoading(true));
                const res = await updateStatusEmailToMailCompany({
                    emailTemplateId: id,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    active: active
                }).then(res => {
                    getMyLeaveRequestPagingWithoutPendingList({ currentCompany, currentEmployee })
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                // dispatch(setIsLoading(false));
            }
        },
        [dispatch],
    )
    const addEmailToMail = useCallback(
        async (
            { id,
                email,
            }) => {
            try {
                // dispatch(setIsLoading(true));
                const res = await addEmailToMailCompany({
                    emailTemplateId: id,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    email: email
                }).then(res => {
                    getMyLeaveRequestPagingWithoutPendingList({ currentCompany, currentEmployee })
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                // dispatch(setIsLoading(false));
            }
        },
        [dispatch, currentCompany, currentEmployee],
    )

    const deleteEmailInCompany = useCallback(
        async (
            { id,
                email,
            }) => {
            try {
                // dispatch(setIsLoading(true));
                const res = await deleteEmailToMailCompany({
                    emailTemplateId: id,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    email: email
                }).then(res => {
                    getMyLeaveRequestPagingWithoutPendingList({ currentCompany, currentEmployee })
                })
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                // dispatch(setIsLoading(false));
            }
        },
        [dispatch, currentCompany, currentEmployee],
    )

    useEffect(() => {
        if (currentCompany, currentEmployee)
            getMyLeaveRequestPagingWithoutPendingList({ currentCompany, currentEmployee })
    }, [currentCompany, currentEmployee])

    function onClose({ email, id }) {
        deleteEmailInCompany({ email, id })
    }


    const handleInputConfirm = (id, value) => {
        addEmailToMail({ email: value.email, id })

    };

    const getCardOne = useCallback(
        () => {
            const language = i18n.language == "en" ? "En" : ""
            function borderRadius(params) {
                return {
                    // borderRadius: params % 2 != 0 ? " 0px 0px 100px 100px" : "100px 100px 0px 0px"
                    borderRadius: "50px 50px 50px 50px"
                }
            }
            return (
                <Col span={24}>
                    <List
                        grid={{
                            column: 1
                        }}
                        itemLayout="vertical"
                        dataSource={emailNotificationList}
                        pagination={false}
                        loading={isLoading}
                        renderItem={(item, index) => {
                            return (
                                <Card
                                    style={{
                                        ...borderRadius(index),
                                        boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)'

                                    }}
                                    styles={{
                                        header: {
                                            marginTop: 20,
                                        }
                                    }}
                                    extra={
                                        <Switch onChange={(e) => {

                                            Modal.confirm({
                                                title: t("dialog.confirmation.header"),
                                                content: (i18n.language === "en" ?
                                                    <p>
                                                        Are you sure confirm to change status ?
                                                    </p>
                                                    :
                                                    <p>
                                                        คุณยืนยันการเปลี่ยนสถานะใช่หรือไม่ ?
                                                    </p>
                                                ),
                                                async onOk() {
                                                    let active = e ? "ACTIVE" : "INACTIVE"
                                                    await updateStatusEmailToMail({ id: item.id, currentEmployee, currentCompany, active })
                                                    //   const modifiedParams = toParams({
                                                    //     page: pagination.page - 1,
                                                    //     size: pagination.size,
                                                    //     sortBy: sorter,
                                                    //   });
                                                    //   getMasterDataList(modifiedParams);
                                                },
                                                okText: t("common.confirm"),
                                                cancelText: t("common.cancel"),
                                            });


                                        }} defaultValue={item.active == "ACTIVE"}></Switch>
                                    }
                                    title={
                                        <List.Item
                                            size="small"
                                            key={item.title}
                                            // extra={}
                                            style={{
                                                // maxWidth: "100%",
                                                // maxHeight: "100%",
                                                // justifyContent: "center"
                                                marginTop: 40,
                                            }}
                                        >
                                            <Space direction='horizontal' size={10}>
                                                <Avatar style={{
                                                    backgroundColor: "lightblue"
                                                }} size={75} icon={<MailOutlined style={{
                                                    color: "white"
                                                }} />}></Avatar>
                                                <List.Item.Meta
                                                    title={item?.["emailEvent" + language]}
                                                    description={item?.["emailEventDescription" + language]}
                                                >
                                                </List.Item.Meta>
                                            </Space>
                                        </List.Item>
                                    }
                                >
                                    <List.Item>
                                        <ListItemForm item={item} onFormFinish={handleInputConfirm} />
                                        <Card styles={{
                                            body: {
                                                padding: 10
                                            }
                                        }}>
                                            {item?.emailList?.map((email, index) => {
                                                const isLongTag = email.length > 20;
                                                const tagElem = (
                                                    <Tag color='blue' key={email} closable onClose={() => onClose({ email, id: item.id })}>
                                                        {isLongTag ? `${email.slice(0, 20)}...` : email}
                                                    </Tag>
                                                );
                                                return isLongTag ? (
                                                    <Tooltip title={email} key={email}>
                                                        {tagElem}
                                                    </Tooltip>
                                                ) : (
                                                    tagElem
                                                );
                                            })}
                                        </Card>
                                    </List.Item>
                                </Card>
                            )
                        }}
                    />
                </Col>
            )
        },
        [isLoading, emailNotificationList, i18n],
    )

    return {
        getCardOne
    }
}
export default useSettingNoti;